/**
 * MarkerM
 *
 *  id based markers
 *
 */
'use strict';

import Utils from '../HlsUtils';
import OrderedArray from './OrderedArray';

/**
* @access internal
*/
class MarkerM {

	constructor(config = {} ) {
		this._markers = new OrderedArray( [], x => x.time );
		this._lastTime = -Infinity;
		this._nextMarkerId = 1;

		Utils.applyConfig(this, config);
	}


	dispose() {
		this._markers = null;
	}


	addMarker( time, data = null, callback = null ) {
		let markerId = this._nextMarkerId;

		Utils.checkNotFiniteAndThrow( time, 'MarkerM.addMarker: time' );

		this._nextMarkerId++;
		if( callback ) {
			if( !Utils.isFunction(callback) ) {
				throw new Error( 'MarkerM.addMarker: callback must be a function if specified' );
			}
		}
		//The OrderedArray is set to use time as the sorter so we need to require time
		let marker = { time, data, callback, markerId };

		if (marker !== undefined && marker !== null && marker.time !== undefined) {
			this._markers.insert(marker);
		}
		else {
			markerId = 0;
		}

		return markerId;
	}


	clearAllMarkers() {
		this._markers.clear();
	}


	removeMarkerRange( start, end, filter) {
		this._markers.extractByValueWithFilter( start, end, filter );
	}


	removeMarker( markerId) {
		var total = this._count;
		this._markers.extractWithFilter( 0, total, (v) => v.markerId === markerId );
	}


	get count() {
		return this._markers.length;
	}


	seekMarkers(time) {
		this._lastTime = time;
	}


	_triggerMarker( marker ) {
		let callback = marker.callback;

		if( callback ) {
			callback( marker.time, marker.data, marker.markerId );
		}
	}


	_triggerMarkers( markers ) {
		markers.forEach( (marker) => this._triggerMarker(marker) );
	}


	timeUpdate(timeNow) {
		if (this._markers.length ) {
			let pickedMarkers = this._markers.sliceByValue({ time:this._lastTime }, { time:timeNow });

			this._triggerMarkers(pickedMarkers);
		}
	}


	timeUpdateWithExtract(timeNow, filter) {
		if( this._markers.length) {
			let pickedMarkers = this._markers.extractByValueWithFilter( { time:this._lastTime }, { time:timeNow }, filter );

			this._triggerMarkers(pickedMarkers);
		}
	}

}
export default MarkerM;



// WEBPACK FOOTER //
// ./src/utils/markerM.js